export const RSC_PATHNAME = '/__rsc';
export const EVENT_PATHNAME = '/__event';
export const EVENT_PATHNAME_REGEX = new RegExp(`^${EVENT_PATHNAME}/`);
export const OXYGEN_SECRET_TOKEN_ENVIRONMENT_VARIABLE = 'SHOPIFY_STOREFRONT_API_SECRET_TOKEN';
export const STOREFRONT_API_SECRET_TOKEN_HEADER = 'Shopify-Storefront-Private-Token';
export const STOREFRONT_API_PUBLIC_TOKEN_HEADER = 'X-Shopify-Storefront-Access-Token';
export const FORM_REDIRECT_COOKIE = 'Hydrogen-Redirect';
export const STOREFRONT_API_BUYER_IP_HEADER = 'Shopify-Storefront-Buyer-IP';
export const SHOPIFY_STOREFRONT_ID_VARIABLE = 'SHOPIFY_STOREFRONT_ID';
export const SHOPIFY_STOREFRONT_ID_HEADER = 'Shopify-Storefront-Id';
export const SHOPIFY_STOREFRONT_Y_HEADER = 'Shopify-Storefront-Y';
export const SHOPIFY_STOREFRONT_S_HEADER = 'Shopify-Storefront-S';
export const SHOPIFY_Y = '_shopify_y';
export const SHOPIFY_S = '_shopify_s';
